export default __webpack_public_path__ + "static/logo12-c5c049176c238199e71be3a36a24c76b.png";